import {AfterContentChecked, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {ContactVO} from '../../../../generate/ContactVO';
import {ChangeVO} from '../../../../generate/ChangeVO';
import {UtilService} from '../../../../util/util.service';

@Component({
  selector: 'contact-info-view',
  templateUrl: './contact-info-view.component.html',
  styleUrls: ['./contact-info-view.component.scss']
})
export class ContactInfoViewComponent implements AfterContentChecked {

  @Input()
  contactVO: ContactVO;

  @Input()
  change: ChangeVO;

  @Input()
  lastchange: string;

  @Input()
  pendingRequestChangeID: string;

  @Output()
  edit = new EventEmitter<boolean>();
  @Input()
  viewMode: boolean;
  constructor(private utilService: UtilService) {
  }

  ngAfterContentChecked() {
  }


  onEdit(): void {
    this.edit.emit(true);
  }

}
